import { render, staticRenderFns } from "./SharingTab.vue?vue&type=template&id=99fa4b6e&scoped=true&lang=pug&"
import script from "./SharingTab.vue?vue&type=script&lang=js&"
export * from "./SharingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fa4b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
